import React, { useState, useContext } from "react";
import GithubContext from "../../context/github/githubContext";
import AlertContext from "../../context/alert/alertContext";

const Search = () => {
  const githubContext = useContext(GithubContext);
  const alertContext = useContext(AlertContext);
  const [text, setText] = useState("");

  const onChange = (e) => setText(e.target.value);

  const onSubmit = (e) => {
    e.preventDefault();
    if (text === "") {
      alertContext.setAlert("Please enter valid text.", "light");
    } else {
      githubContext.searchUsers(text, true);
      setText("");
    }
  };

  return (
    <div style={{width: "100%"}}>
      <form onSubmit={onSubmit} className="search-form">
        <input
          type="text"
          name="text"
          placeholder="Search GitHub users..."
          autoComplete="off"
          value={text}
          onChange={onChange}
          disabled={githubContext.loading}
        />
        <button type="submit" className="btn btn-primary" disabled={githubContext.loading}>
          {githubContext.loading ? "Searching..." : "Search"}
        </button>
      </form>
      {githubContext.users.length > 0 && (
        <button
          className="btn btn-light btn-block"
          onClick={githubContext.clearUsers}
          disabled={githubContext.loading}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default Search;
